import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)

const tpl = {
  template: '<router-view></router-view>'
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/correctWrong'
    },
    {
      path: '/correctWrong',
      name: 'CorrectWrong',
      component: r => require.ensure([], () => r(require('@/views/correctWrong')), 'CorrectWrong'),
      meta: {
        title: '错题订正'
      }
    },
    {
      path: '/learningSituationTest',
      name: 'learningSituationTest',
      component: r => require.ensure([], () => r(require('@/views/learningSituationTest')), 'learningSituationTest'),
      meta: {
        title: '学情报告'
      }
    },
    {
      path: '/onlineQuiz',
      name: 'onlineQuiz',
      component: r => require.ensure([], () => r(require('@/views/onlineQuiz')), 'onlineQuiz'),
      meta: {
        title: '在线答题'
      }
    },
    {
      path: '/mistakeDetails',
      name: 'mistakeDetails',
      component: r => require.ensure([], () => r(require('@/views/mistakeDetails')), 'mistakeDetails'),
      meta: {
        title: '题目分析'
      }
    },
    {
      path: '/pdfPreview',
      name: 'pdfPreview',
      component: r => require.ensure([], () => r(require('@/views/pdfPreview')), 'pdfPreview'),
      meta: {
        title: 'PDF'
      }
    }
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js